import { Col, Row } from "react-bootstrap";
import { EViewSolarEstimationSolarProductCategory } from "../../../../shared/oversight-core/enums/view-solar-estimation-solar-product-category";
import MaterialIcon from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import { formatWithCommas } from "../../../../shared/oversight-core/utils/format-with-commas";
import styles from "./solar-component.module.scss";

export interface ISelectedSolarComponent {
  id: number;
  category: EViewSolarEstimationSolarProductCategory;
}

export interface ISolarComponent {
  id: number;
  category: EViewSolarEstimationSolarProductCategory;
  name: string;
  quantity: number;
  value: number;
  unit: string;
}

interface IProps {
  component: ISolarComponent;
  selected: ISelectedSolarComponent;
  onSelect: (
    id: number,
    category: EViewSolarEstimationSolarProductCategory
  ) => void;
  isWarning: boolean;
}

const SolarComponent = (props: IProps) => {
  const { selected, onSelect, component, isWarning } = props;
  const { id, category, name, quantity, value, unit } = component;

  const isSelected = selected.id === id;

  return (
    <div
      onClick={() => onSelect(id, category)}
      className={`cursor-pointer ${
        isSelected ? "bg-primary" : "theme-card-4"
      } ${styles.solarComponentWrapper} rounded-3 py-2 px-3`}
    >
      <Row className="align-items-center flex-nowrap g-2">
        <Col xs="auto" className="pe-0 d-flex align-items-center">
          <MaterialIcon
            icon={
              category === EViewSolarEstimationSolarProductCategory.INVERTERS
                ? "tablet_mac"
                : category ===
                  EViewSolarEstimationSolarProductCategory.BATTERIES
                ? "battery_horiz_000"
                : category === EViewSolarEstimationSolarProductCategory.PANELS
                ? "solar_power"
                : category ===
                  EViewSolarEstimationSolarProductCategory.WATER_HEATER_CONTROLLERS
                ? "google_tv_remote"
                : category ===
                  EViewSolarEstimationSolarProductCategory.WATER_HEATERS
                ? "propane"
                : "tune"
            }
            color={isSelected ? "#fff" : "var(--color-component-icon)"}
          />
        </Col>
        <Col className="px-2 flex-grow-1" style={{ minWidth: 0 }}>
          <div
            className={`${
              isSelected ? "text-white" : "text-label"
            } fw-semibold text-truncate`}
            title={name}
          >
            {name}
          </div>
          <div
            className={`${
              isSelected ? "text-white" : "title-3"
            } small fw-medium text-truncate`}
            title={`${unit} ${value}`}
          >
            {unit}&nbsp;{formatWithCommas(value)}
          </div>
        </Col>
        <Col xs="auto">
          <Row className="align-items-center">
            {isWarning && (
              <Col>
                <MaterialIcon icon="warning" color="#f0cc39ff" />
              </Col>
            )}
            <Col
              xs="auto"
              className={`${
                isSelected ? "text-white" : "text-label"
              } fw-semibold fs-4 ps-2`}
            >
              x{quantity}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default SolarComponent;
